export default __webpack_public_path__ + "static/media/inspection-icon.d511f413.webp";